import {CircleQuestionMarkIcon} from 'lucide-react';
import {cn} from '@chekin/guestapp-ui-kit';
import {Button} from '@chekinapp/ui';
import {useMemo} from 'react';

type QuestionMarkAndTextProps = {
  onClick: () => void;
  text?: string;
  iconSize?: number | string;
  className?: string;
};

function QuestionMarkAndText({
  onClick,
  text,
  iconSize = 16,
  className,
}: QuestionMarkAndTextProps) {
  const iconSizeClass = useMemo(() => {
    const internalSize = iconSize || 16;

    if (typeof internalSize === 'number') {
      return `w-[${internalSize}px] h-[${internalSize}px]`;
    }

    return `w-[${internalSize}] h-[${internalSize}]`;
  }, [iconSize]);

  return (
    <Button
      variant="link"
      onClick={onClick}
      className={cn(
        className,
        'inline-flex items-center gap-[5px] p-0 text-[var(--text-button-color)]',
        'kiosko:gap-4',
      )}
    >
      <CircleQuestionMarkIcon className={cn(iconSizeClass, 'kiosko:w-10 kiosko:h-10')} />
      <span
        className={cn(
          'font-[var(--large-font-weight)] text-[length:var(--s-font-size)] leading-6 tracking-[-0.15px]',
          'kiosko:text-kiosko-s',
        )}
      >
        {text ?? ''}
      </span>
    </Button>
  );
}

export {QuestionMarkAndText};
